module.exports = __webpack_public_path__ + "img/newDepartmentBtn.14b3d467.png";